import { useEffect, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useGetParams } from '../../hooks/useGetParams';

import Message from '../Message/Message';
import styles from './MessagesList.module.css';

import bgVideo from '../../assets/video/bgVideo.webm';
import wave from '../../assets/video/wave.webm';

import sharkRight from '../../assets/video/sharkRight.webm';
import sharkLeft from '../../assets/video/sharkLeft.webm';

import logo from '../../assets/images/logo.png';
import delo from '../../assets/images/delo.png';
import ncsp from '../../assets/images/ncsp.png';

export const MessagesList = ({
  messages,
  speed,
  activeSharkRight,
  activeSharkLeft,
}) => {
  const { authorFontSize, user } = useGetParams();

  const sharkRightRef = useRef(null);
  const sharkLeftRef = useRef(null);

  useEffect(() => {
    sharkRightRef.current.play();
  }, [activeSharkRight]);

  useEffect(() => {
    sharkLeftRef.current.play();
  }, [activeSharkLeft]);

  return (
    <div className={styles['wrapper']}>
      <img src={logo} alt="logo" className={styles.logo} />
      <img src={delo} alt="delo" className={styles.delo} />
      <img src={ncsp} alt="ncsp" className={styles.ncsp} />

      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages.length > 0 &&
            messages.map((item, i) => {
              const msg = item.message;
              const key = item.id;

              return (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                  appear={true}
                >
                  <Message
                    key={key}
                    message={msg}
                    authorFontSize={authorFontSize}
                    user={user}
                    rotateSign={item.rotateSign}
                    speed={speed}
                    randomDelay={item.randomDelay}
                  />
                </CSSTransition>
              );
            })}
        </TransitionGroup>
      </div>

      <video playsInline autoPlay="autoplay" muted="muted" loop id="bgVideo">
        <source src={bgVideo} type="video/webm" />
      </video>

      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        style={{ zIndex: -90 }}
      >
        <source src={wave} type="video/webm" />
      </video>

      <video playsInline muted="muted" id="bgVideo" ref={sharkRightRef}>
        <source src={sharkRight} type="video/webm" />
      </video>

      <video playsInline muted="muted" id="bgVideo" ref={sharkLeftRef}>
        <source src={sharkLeft} type="video/webm" />
      </video>
    </div>
  );
};
